import { Analytics } from "./types.ts";
import { useContext } from "react";
import AnalyticsContext from "./AnalyticsContext.tsx";

export const useAnalytics = (): Analytics => {
  return useContext(AnalyticsContext);
};
